import React, { useContext } from 'react'
import { AppContext } from '../App'
import { missingImageUrl } from '../config.json'

export default function ProductType({ value, text, categoryImage }) {
   const { 
      setCurrentStep,
      setAppHeader,
      setLinkGoBackTarget,
      productOptionsSelected,
      setProductOptionsSelected
   } = useContext(AppContext)

   const imgUrlBase = 'https://cdn.laticrete.com'
   const imgUrl = categoryImage ? imgUrlBase + categoryImage : missingImageUrl

   const handleSelectProductType = () => {
      // Set the appHeader for Step state, dependent on product type (text) selected.
      switch(value) {
         case "adhesives": setAppHeader("Step 1 of 2"); break
         case "grout": setAppHeader("Step 1 of 2"); break
         case "resinous": setAppHeader("Step 1 of 4"); break
         case "underlayments": setAppHeader("Step 1 of 2"); break
         default: alert("No product type selected.")
      }

      // Set the Go Back link
      setLinkGoBackTarget({ link: "productTypeSelection" })

      // Add the selected resinous application to state of App.
      productOptionsSelected.productOptions.push(text)
      setProductOptionsSelected({ productOptions: productOptionsSelected.productOptions })
      
      // Update the current step, dependent on product type was selected.
      switch(value) {
            case "adhesives": setCurrentStep({ step: "adhesivesProductSelection" }); break
            case "grout": setCurrentStep({ step: "groutProductSelection" }); break
            case "resinous": setCurrentStep({ step: "resinousApplicationSelection" }); break
            case "underlayments": setCurrentStep({ step: "underlaymentProductSelection" }); break
            default: console.log("Error: No product type selected.")
      }
    }
    
   return (    
      <div className="list-item" key={ value } onClick={ handleSelectProductType } >
         <div className="row p-1">
               <div className="col-xs-3 vcenter">
                  <figure>
                     <img src={ imgUrl } alt="Alt text" className="img-responsive" />
                  </figure>
               </div>
               <div className="col-xs-9 vcenter">
                  <h4>{ text }</h4>
               </div>
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/ProductType.js